module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAZCAYAAABdEVzWAAAACXBIWXMAAAsSAAALEgHS3X78AAABNklEQVRIx81XURWDMBALDpCABCQgAQlIqQQkVAISkIIEHGQfKxtrC/SuhTfey3uwUZbjLmlWgbQADIEFf3BUQP8+I+kwgey+l88C5ABycR8YRO6aQfYPkalBGpCr92WU2IYF5HAToQakjRBKIrZhdVXVBQh1jtDVzUnE9gQtyEZJaBYsEhHbw6YIxRtoSokZ5eKoUHYDnfPMtkR1H6GAHE8GWtQFgGy9invhPOQgmFv3xhvsXt+gVJCW0I/SPU8Lhn9rSS3wHHHLEzztUJVXFZUQyVlHkuwi8C6BUIL9N3GGRT5mBT+SU4zaYI/aMhVsv0Gudyk36SsM2r0sKhTn2DbjOeM2An6l7Y3eJUovZ3lpLORdqrynTZg5SErI2kx+W1QSE1Nu8jnh8paYnB3HS/+xCEKAFi/1iFeToXo97wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/botArrow.png
// module id = d3bx
// module chunks = 1